import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { Button, Container } from "reactstrap";
import Common from "../Common";
import CurrentPlan from "./CurrentPlan";
import { useStepsContext } from "../Subscription/context";
import SubscriptionBilling from "../Subscription/SubscriptionBilling";
import SubscriptionPlans from "../Subscription/SubscriptionPlans";
import SubscriptionConfirm from "../Subscription/SubscriptionConfirm";
import CancelPage from "./CancelPage";
import { isMobile, updateBillInfo } from "../../Common/Appcommon";

const Usage = ({isUsage}) => {
    const { 
        currentStep, 
        setCurrentStep, 
        showLoading, 
        paymentDetails, 
        setIsUsage, 
        callPaymentFunc, 
        selectedPlan, 
        isAgency,
        handleSubmitClick
    } = useStepsContext();
    const [onClick,setOnclick] = useState(false);
    const handleClick = (val) => {
        setOnclick(val);
    };
    useEffect(() => {
        if(isUsage && currentStep !== 4 && currentStep !== 2){
            setIsUsage(isUsage);
            if(Object.keys(paymentDetails).length > 1){
                setCurrentStep(6);
            }else{
                setCurrentStep(7);
            }
        }
    }, [paymentDetails]);

    let title = "Plan & Billing Info";
    let buttonlabel = "Update Plan";
    if(currentStep === 2 || currentStep === 7 || !isUsage){
        title = "Plan & Billing";
        buttonlabel = "Subscribe Plan";
        if(isAgency){
            buttonlabel = "Buy "+selectedPlan.plan_name+" Plan";
        }
    }

    return(
        <Common
            title={title}
            titleContent={
                <span>
                    {title}
                </span>
            }
            titleBody={
                (!isMobile() && (currentStep === 4 || currentStep === 2)) && (
                    <Button
                        onClick={buttonlabel === "Update Plan" ? () => handleClick(true) : handleSubmitClick}
                        // onClick={buttonlabel === "Update Plan" ?  handleClick(true) : e => handleSubmitClick()} 
                        className="theme-bg-g m-1"
                        disabled={showLoading}
                    >
                        {buttonlabel}
                    </Button>
                )
            }
            mainLoader={showLoading}
            mainContent={
                <Fragment>
                    <Container fluid>
                        {
                            currentStep === 1 && <SubscriptionPlans showLoader={showLoading}/>
                        }
                        {
                            currentStep === 2 && <SubscriptionBilling refrence={onClick} />
                        }
                        {
                            currentStep === 3 && <SubscriptionConfirm/>
                        }
                        {
                            currentStep === 4 && <SubscriptionBilling refrence={onClick} handleClick={handleClick}/>
                        }
                        {
                            currentStep === 5 && <CancelPage/>
                        }
                        { 
                            currentStep === 6 && <CurrentPlan/>
                        }
                        {
                            currentStep === 7 && <SubscriptionPlans showLoader={showLoading}/>
                        }
                    </Container>
                </Fragment>
            }
        />
    )
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Usage);